import { invariant } from '@mimir/common/util/invariant';
import type { OpaqueRefCountedBuffer } from '@mimir/cutter/frameProvider/frameProvider';

export class ImageBitmapBuffer implements OpaqueRefCountedBuffer {
  refcount = 1;
  constructor(readonly imageBitmap: ImageBitmap) {
  }

  addReference(): OpaqueRefCountedBuffer {
    if (this.refcount <= 0) {
      throw new Error('Cannot add reference to a closed ImageBitmapBuffer');
    }
    ++this.refcount;
    return this;
  }
  size(): number {
    return this.imageBitmap.width * this.imageBitmap.height * 4; // Assuming RGBA format
  }
  copyTo(target: Uint8Array): Promise<void> {
    if (this.refcount <= 0) {
      return Promise.reject(new Error('Cannot copy from a closed ImageBitmapBuffer'));
    }
    const canvas = getReusableTemporaryCanvas();
    canvas.width = this.imageBitmap.width;
    canvas.height = this.imageBitmap.height;
    const ctx = canvas.getContext('2d');
    invariant(ctx, '2D context should be available');
    ctx.drawImage(this.imageBitmap, 0, 0);
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    target.set(new Uint8Array(imageData.data.buffer));
    return Promise.resolve();
  }
  close(): void {
    --this.refcount;
    if (this.refcount <= 0) {
      this.imageBitmap.close();
    }
  }
}

let reusableTemporaryCanvas: HTMLCanvasElement | null = null;

function getReusableTemporaryCanvas(): HTMLCanvasElement {
  reusableTemporaryCanvas ??= document.createElement('canvas');
  return reusableTemporaryCanvas;
}
